export class DocumentMock extends Document {
    public readyState: DocumentReadyState = 'loading';
}